import React, { Component, createContext } from 'react';

const UtilsCtx = createContext();

export class UtilsProvider extends Component {
  state = {
    // eslint-disable-next-line react/no-unused-state
    uploading: false,
  };

  // eslint-disable-next-line react/no-unused-state
  setUploading = uploading => this.setState({ uploading });

  render() {
    return (
      <UtilsCtx.Provider
        value={{
          state: this.state,
          actions: {
            setUploading: this.setUploading,
          },
        }}
      >
        {/* eslint-disable-next-line react/prop-types */}
        {this.props.children}
      </UtilsCtx.Provider>
    );
  }
}

export const withUtilsConsumer = WrappedComponent => props => (
  <UtilsCtx.Consumer>
    {ctx => <WrappedComponent ctx={ctx} {...props} />}
  </UtilsCtx.Consumer>
);
